<template>
  <v-container style="max-width: 800px" class="py-8">
    <div v-if="isLoading" class="d-flex justify-center py-12">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <template v-else-if="terms">
      <h1 class="text-h5 font-weight-bold mb-6">{{ terms.title }}</h1>
      <v-card variant="outlined" class="pa-6">
        <span
          class="text-body-1"
          style="line-height: 1.8"
          v-html="sanitizedContent"
        />
      </v-card>
    </template>
    <v-alert v-else-if="notFound" type="info" variant="tonal">
      No terms and conditions have been set for this venue.
    </v-alert>
    <v-alert v-else type="error" variant="tonal">
      Unable to load terms and conditions. Please try again later.
    </v-alert>
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { useTitle } from "@common/composables/useTitle";
import { sanitizeHtml } from "@common/utils";
import { getVenueTerms, type TermsResponse } from "../api/termsApi";

const props = defineProps<{ venueId: number }>();

const terms = ref<TermsResponse | null>(null);
const isLoading = ref(true);
const notFound = ref(false);

useTitle("Venue Terms and Conditions");

const sanitizedContent = computed(() =>
  terms.value ? sanitizeHtml(terms.value.content) : "",
);

onMounted(async () => {
  try {
    terms.value = await getVenueTerms(props.venueId);
  } catch (err: any) {
    if (err?.response?.status === 404) {
      notFound.value = true;
    }
    // For any other error, terms stays null and the error alert is shown
  } finally {
    isLoading.value = false;
  }
});
</script>
